import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import BaseButton from "../BaseButton";

const DigitalSignature = ({
  handleSignatureCompleted,
  defaultSignature,
  onClear,
}) => {
  const signaturePad = useRef(null);
  const [isSigned, setIsSigned] = useState(false);

  useEffect(() => {
    const loadSignature = async () => {
      if (defaultSignature && signaturePad.current) {
        const base64 = await imageUrlToBase64(defaultSignature);
        signaturePad.current?.fromDataURL(base64);
        setIsSigned(true);
      }
    };

    loadSignature();
  }, [defaultSignature]);

  const imageUrlToBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const handleEnd = () => {
    const dataURL = signaturePad.current.toDataURL(); // Get the base64 signature
    const byteString = atob(dataURL.split(",")[1]); // Decode the base64 string
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    // Convert base64 to binary data
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    // Create a Blob from the binary data
    const blob = new Blob([uint8Array], { type: "image/png" });

    handleSignatureCompleted(blob);
  };

  const clearSignature = () => {
    signaturePad.current.clear();
    onClear();
  };

  return (
    <div className="flex flex-col">
      <SignatureCanvas
        ref={signaturePad}
        penColor="black"
        canvasProps={{
          width: 500,
          height: 130,
          className: "signature-canvas",
        }}
        onEnd={handleEnd} // This is triggered when the user finishes drawing
      />
      {/* <div>{isSigned ? "Signature complete" : "Please sign above"}</div> */}

      <div className="flex justify-end mt-3 mb-2">
        <BaseButton
          onClick={clearSignature}
          variant="outlined"
          color="primary"
          className="px-[0] py-[0] mx-3"
        >
          Clear
        </BaseButton>
        {/* <BaseButton
          onClick={saveSignature}
          variant="outlined"
          color="primary"
          className="px-[0] py-[0] mx-3"
        >
          Save
        </BaseButton> */}
      </div>
    </div>
  );
};

export default DigitalSignature;
